import { useState } from "react";
import { ArrowRight } from "lucide-react";

export default function FinalCTA({ onSubmit, loading, submitted, message, submittedRank, waitlistCount }) {
  const [email, setEmail] = useState("");
  const [localError, setLocalError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setLocalError("");
    const trimmed = email.trim();
    if (!trimmed) {
      setLocalError("Please enter a valid email address.");
      return;
    }
    onSubmit(trimmed);
  };

  return (
    <section id="final-cta" className="nm-section-light reveal-section" data-reveal data-testid="final-cta-section">
      <div className="nm-container py-20 md:py-24">
        <div className="pb-8">
          <span className="nm-eyebrow inline-block text-black/50">
            Join EDITH
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 py-10 md:py-16">
          <div className="pr-0 lg:pr-10">
            <h2 className="text-[clamp(2.2rem,5vw,4.4rem)] text-black leading-none">
              Stop
              <br />
              restarting.
              <br />
              <span className="text-black/30">Start</span>
              <br />
              <span className="bg-[#111] text-white px-3 py-1 inline-block mt-2 rounded-lg">
                finishing.
              </span>
            </h2>
          </div>

          <div className="pl-0 lg:pl-10 pt-4 lg:pt-0 flex flex-col justify-center">
            <p className="text-lg text-black/70 mb-8 max-w-sm font-medium">
              EDITH beta is launching soon. No payment. No credit card. Show up, or spend another month explaining why you didn't.
            </p>

            {submitted ? (
              <div className="bg-[#fafafa] p-6 border border-black/10 rounded-xl" data-testid="final-success">
                <p className="text-black text-sm font-bold">
                  You're #{submittedRank ?? waitlistCount} on the list. EDITH will find you when it's time.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="flex flex-col gap-3 max-w-md" data-testid="final-waitlist-form">
                <label className="text-[10px] font-bold tracking-[0.2em] uppercase text-black/50 block">
                  Your email
                </label>
                <input
                  type="email"
                  placeholder="your@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="final-email-input"
                  className="bg-[#f4f4f5] border border-black/20 rounded-xl px-5 py-4 text-[16px] text-black placeholder:text-black/50 focus:outline-none focus:border-black"
                />
                <button
                  type="submit"
                  disabled={loading}
                  data-testid="final-submit-btn"
                  className="bg-black text-white px-5 py-4 text-sm font-bold flex items-center justify-center gap-2 disabled:opacity-50 rounded-xl hover:bg-black/80 transition-colors"
                >
                  {loading ? "Joining..." : "Join the Waitlist"}
                  {!loading && <ArrowRight size={15} strokeWidth={2.5} />}
                </button>
                {(localError || message) && !submitted && (
                  <p role="alert" className="mt-2 text-sm text-red-600 font-medium" data-testid="final-message">
                    {localError || message}
                  </p>
                )}
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
